// care.ts — copy for the CARE reflection (Check-in · Anchoring · Reflection ·
// Empowerment), offered after a Settle-My-Emotions session.

export const CARE_SECTION = 'Learning to calm triggered emotions';
export const CARE_PROMPT_TITLE = 'Process your triggered emotions to reduce their power in the future';
export const CARE_PROMPT_SUBTITLE = 'Return to this when you have time. It will wait for you until you are ready.';
export const CARE_TAGLINE = 'The CARE approach to settling and stabilising triggered trauma, as you learn to rebuild your life.';

// C — Check-in (body sensations, not thoughts) — shown as example questions the
// user gently asks themselves, not a checklist.
export const BODY_QUESTIONS = [
  'Were my shoulders tense?',
  'Was my stomach upset or churning?',
  'Did my breath become short?',
  'Did my chest become tight?',
  'Did my head become light or dizzy?',
];

// E — Empowerment examples
export const EMPOWERMENT_EXAMPLES = [
  'Not replying to an ex straight away, and replying when I choose to',
  'Returning to a relaxation exercise',
  'Connecting with a friend, or doing something fun',
  'Having a bath, or reading a book',
];
